import { render, staticRenderFns } from "./LeftBlock.vue?vue&type=template&id=60724ebf&scoped=true"
import script from "./LeftBlock.vue?vue&type=script&lang=js"
export * from "./LeftBlock.vue?vue&type=script&lang=js"
import style0 from "./LeftBlock.vue?vue&type=style&index=0&id=60724ebf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60724ebf",
  null
  
)

export default component.exports